module.exports = __webpack_public_path__ + "img/5.21308ea8.png";